import type { FC } from 'react';
import { Typography } from '@interstate/components/Typography';
import type { ReviewViewProps } from '../types';
import {
    ReviewContainer,
    ReviewHeader,
    WillAttachToSection,
    ChangeSummarySection,
    ChangeSummaryColumns
} from '../CreditAppSearch.styles';
import { ChangeSummaryCard } from '../components/ChangeSummaryCard';
import { valueOrDash } from '../utils/resultCardMappers';

export const ReviewAttachView: FC<ReviewViewProps> = ({ currentDealData, newDealData }) => {
    const buyerName = `${currentDealData.buyer.firstName} ${currentDealData.buyer.lastName}`.trim();

    return (
        <ReviewContainer data-testid="review-view">
            <ReviewHeader>
                <Typography variant="h4">Review & Attach</Typography>
                <Typography variant="body-sm">Review the final changes before applying them to the deal.</Typography>
            </ReviewHeader>

            <WillAttachToSection>
                <Typography variant="h4">Will Attach To:</Typography>
                <Typography variant="strong-md" data-testid="customer-name">
                    {valueOrDash(buyerName)}
                </Typography>
            </WillAttachToSection>

            <ChangeSummarySection>
                <Typography variant="h4">Change Summary</Typography>
                <ChangeSummaryColumns>
                    <ChangeSummaryCard
                        title="Current"
                        description="The following information is currently associated with this deal:"
                        dealData={currentDealData}
                        testId="change-summary-current"
                    />
                    <ChangeSummaryCard
                        title="New"
                        description="The following information will be attached to the current deal:"
                        dealData={newDealData}
                        testId="change-summary-new"
                        isNew
                    />
                </ChangeSummaryColumns>
            </ChangeSummarySection>
        </ReviewContainer>
    );
};
